<template>
  <!-- confirm START -->
  <transition name="fade" mode="out-in">
    <div class="dialog dialog-confirm" v-if="loadingVisible">
      <div class="dialog-confirm-container">

        <div class="inner">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M336 208v-95a80 80 0 00-160 0v95" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><rect x="96" y="208" width="320" height="272" rx="48" ry="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>
          </div>
          <h4 v-html="headline"></h4>
          <div class="excerpt" v-html="excerpt"></div>

          <div class="dialog-footer">
            <div
              class="btn-inverted close"
              v-on:click="close()"
              v-on:touchstart="touchStart($event)"
              v-on:touchend="touchEnd($event);"
              v-on:touchcancel="touchEnd($event)"
              v-html="`
                ${$t('terminal.index.dialog.confirm.no')},
                 ${$t('terminal.index.cart.purchase.abort')}`
              "
            ></div>
            <div
              class="btn-default confirm btn-default-blue"
              v-on:click="confirm()"
              v-on:touchstart="touchStart($event)"
              v-on:touchend="touchEnd($event);"
              v-on:touchcancel="touchEnd($event)"
              v-html="$t('terminal.index.dialog.confirm.yes')"
            ></div>
          </div>

          <div class="abort">
            <span class="description" v-html="description"></span>
          </div>

          <!-- cart:actions:checkout:abort START -->
          <div
            class="abort"
            v-on:click="resetStoreCart()"
            v-if="false"
          >
            <span v-html="$t('terminal.index.cart.purchase.abort')"></span>

            <div class="description" v-html="description"></div>
          </div>
          <!-- cart:actions:checkout:abort END -->
        </div>
      </div>
    </div>
  </transition>
  <!-- confirm END -->
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'dialog-confirm',
  props: {
    data: {
      type: Object,
    },

    loadingVisible: {
      type: Boolean,
      default: false,
    },

    headline: {
      type: String,
    },

    excerpt: {
      type: String,
    },

    description: {
      type: String,
    },

    open: {
      type: Function,
    },

    close: {
      type: Function,
    },

    confirm: {
      type: Function,
    },
    newMessage: {
      type: Number,
    },
  },
  methods: {
    ...mapActions([
      'clearCart',
    ]),

    touchStart(event) {
      event.target.classList.add('pressed');
    },

    touchEnd(event) {
      event.target.classList.remove('pressed');
    },

    async resetStoreCart() {
      // reset store cart
      await this.clearCart();

      const formData = new FormData();
      /**
       * Locale
       */
      formData.append('locale', localStorage.getItem('boxLang'));
      // Logout data
      await this.$http.post(`${localStorage.getItem('anybox_terminal_api_url')}/logout`, formData, {
        headers: {
          'X-Api-Key': `${localStorage.getItem('anybox_terminal_api_key')}`,
          Authorization: `Bearer ${localStorage.getItem('auth')}`,
        },
      })
        .then((response) => {
          if (response.data) {
            // mutating to store for client rendering &
            // saving token in cookie for server rendering
            this.$store.commit('SET_AUTH', null);
            localStorage.removeItem('auth');

            // mutating to store for client rendering &
            // saving user data in cookie for server rendering
            this.$store.commit('SET_USER', null);
            localStorage.removeItem('user');

            // clear other important data
            localStorage.removeItem('qrcodeActive');
          }
        });

      // redirect to home + reload app
      window.location.assign('/');
    },
  },
};
</script>
